import { gql } from 'apollo-boost';

export const createLocationMutation = gql`
  mutation createLocationMutation($location: LocationCreateInput!) {
    location {
      create(location: $location) {
        rowVersion
        id
      }
    }
  }
`;

export const updateLocationMutation = gql`
  mutation updateLocationMutation($location: LocationUpdateInput!) {
    location {
      update(location: $location) {
        rowVersion
        id
      }
    }
  }
`;

export const deleteLocationMutation = gql`
  mutation deleteLocationMutation($locationId: Int!) {
    location {
      delete(locationId: $locationId)
    }
  }
`;
export const linkContactMutation = gql`
  mutation linkContactMutation($linkInfo: LocationContactLinkInput!) {
    location {
      linkContact(linkInfo: $linkInfo) {
        id
        rowVersion
      }
    }
  }
`;

export const setPrimaryContactMutation = gql`
  mutation setPrimaryContactMutation(
    $primaryContactInfo: SetPrimaryContactOnLocationInput!
  ) {
    location {
      setPrimaryContact(primaryContactInfo: $primaryContactInfo) {
        id
        rowVersion
      }
    }
  }
`;

export const unlinkContactMutation = gql`
  mutation unlinkContactMutation($locationContactLinkId: Int!) {
    location {
      unlinkContact(locationContactLinkId: $locationContactLinkId)
    }
  }
`;
